// DASS-21 ÖZEL HESAPLAMA MOTORU (Kurşungeçirmez Versiyon)
export const calculateDass21 = (answers) => {
  let D = 0, A = 0, S = 0;
  
  const map = {
    D: [3, 5, 10, 13, 16, 17, 21], // Depresyon Maddeleri
    A: [2, 4, 7, 9, 15, 19, 20],   // Anksiyete Maddeleri
    S: [1, 6, 8, 11, 12, 14, 18]   // Stres Maddeleri
  };
  
const normalizedAnswers = {};
  Object.keys(answers || {}).forEach(key => {
    // 🔥 KESİN ÇÖZÜM: Key ne olursa olsun (örn: "soru_13", "q13", "13") içindeki rakamı çek
    const id = parseInt(String(key).replace(/\D/g, ''), 10);
    
    // 🔥 NaN KORUMASI: Boş veya tanımsız verileri 0 kabul et
    const rawVal = answers[key];
    const val = (rawVal === "" || rawVal === undefined || rawVal === null) ? 0 : (parseInt(rawVal) || 0);
    if (!Number.isNaN(id)) {
  normalizedAnswers[id] = val;
}

    if (map.D.includes(id)) D += val;
    if (map.A.includes(id)) A += val;
    if (map.S.includes(id)) S += val;
  });
  
  // DASS-21 kuralı: Orijinal tabloyla kıyaslamak için sonuçlar 2 ile çarpılır
  const scores = { D: D * 2, A: A * 2, S: S * 2 };

  // DASS-21 anksiyete alt ölçeğindeki
// doğrudan bedensel belirti bildiren maddeler.
//
// Amaç:
// Toplam Anksiyete puanından belirti VARSAYMAK yerine,
// öğrencinin gerçekten işaretlediği maddeleri rapora taşımak.

const somaticItemDefinitions = [
  {
    id: 2,
    label: "Ağız kuruluğu"
  },
  {
    id: 4,
    label: "Nefes alma güçlüğü"
  },
  {
    id: 7,
    label: "Titreme"
  },
  {
    id: 19,
    label: "Kalp atımını belirgin hissetme"
  }
];


const somaticItems =
  somaticItemDefinitions.map(
    item => ({
      ...item,

      value:
        Number(
          normalizedAnswers[item.id]
        ) || 0
    })
  );


const somaticSignals = {

  items:
    somaticItems,

  // En az bir derece işaretlenen maddeler
  endorsedCount:
    somaticItems.filter(
      item =>
        item.value >= 1
    ).length,

  // "Oldukça sık" veya "her zaman"
  // düzeyinde bildirilen maddeler
  elevatedCount:
    somaticItems.filter(
      item =>
        item.value >= 2
    ).length,

  maxValue:
    Math.max(
      0,
      ...somaticItems.map(
        item =>
          item.value
      )
    )
};
  
  let isCritical = false, isHigh = false, isMedium = false;

  let dLevel = "Normal";
  if (scores.D >= 28) { dLevel = "Çok İleri"; isCritical = true; }
  else if (scores.D >= 21) { dLevel = "İleri"; isHigh = true; }
  else if (scores.D >= 14) { dLevel = "Orta"; isMedium = true; }
  else if (scores.D >= 10) { dLevel = "Hafif"; }

  let aLevel = "Normal";
  if (scores.A >= 20) { aLevel = "Çok İleri"; isCritical = true; }
  else if (scores.A >= 15) { aLevel = "İleri"; isHigh = true; }
  else if (scores.A >= 10) { aLevel = "Orta"; isMedium = true; }
  else if (scores.A >= 8) { aLevel = "Hafif"; }

  let sLevel = "Normal";
  if (scores.S >= 34) { sLevel = "Çok İleri"; isCritical = true; }
  else if (scores.S >= 26) { sLevel = "İleri"; isHigh = true; }
  else if (scores.S >= 19) { sLevel = "Orta"; isMedium = true; }
  else if (scores.S >= 15) { sLevel = "Hafif"; }

  let riskLevel = "low";
  let summary = "Normal Düzey";
  let severity = "normal";

  if (isCritical) { 
      riskLevel = "high"; severity = "critical"; summary = "Öncelikli Risk (Çok İleri Düzey)"; 
  } else if (isHigh) { 
      riskLevel = "high"; severity = "high"; summary = "Yüksek Risk Düzeyi"; 
  } else if (isMedium) { 
      riskLevel = "medium"; summary = "Orta Düzey Risk (İzleme Önerilir)"; 
  }

  // 🔥 PDF İÇİN HAYATİ BÖLÜM: TEPE SKORLAR
  const maxD = 42, maxA = 42, maxS = 42;

  const chartData = [
    { subject: "Depresyon", A: Math.round((scores.D / maxD) * 100), rawCount: scores.D, maxScore: maxD, total: maxD, fullMark: 100 },
    { subject: "Anksiyete", A: Math.round((scores.A / maxA) * 100), rawCount: scores.A, maxScore: maxA, total: maxA, fullMark: 100 },
    { subject: "Stres", A: Math.round((scores.S / maxS) * 100), rawCount: scores.S, maxScore: maxS, total: maxS, fullMark: 100 }
  ].sort((a, b) => b.A - a.A);

  // --- YENİ EKLENEN STANDART PAKETLEME (ZARF) ---
  return {
    // 1. Ortak Dil (StudentFolders burayı okuyacak)
    riskScore: Math.round(chartData[0].A), // En yüksek alanın 100 üzerinden yüzdesi
    masterRisk: riskLevel, // Senin kodunda zaten harika bir şekilde "high", "medium", "low" olarak süzülüyor
    isCritical: isCritical, // Herhangi bir alan "Çok İleri" ise sistemde kırmızı alarm (Öncelikli Vaka) yakar
    domain: "psychological", // PDR alanı: Duygusal/Psikolojik

    // 2. Mevcut Detaylı Veriler (Dashboard, Rapor ve PDF için dokunmadık)
    summary,
    riskLevel, // Geriye dönük uyumluluk için
    severity,
    levels: { Depresyon: dLevel, Anksiyete: aLevel, Stres: sLevel }, 
   scores: scores,

somaticSignals:
  somaticSignals,

chartData: chartData,

topStyle:
  chartData[0].subject,

confidenceScore: 100
  };
};